import { render, staticRenderFns } from "./Spacer1.vue?vue&type=template&id=1d1901e1"
import script from "./Spacer1.vue?vue&type=script&lang=js"
export * from "./Spacer1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports